import { GameVars } from "./GameVars";
import { PenaltyFootballFieldState } from "./scenes/penalty-scene/PenaltyFootBallFieldState";
import { PenaltyManager } from "./PenaltyManager";
import { MatchManager } from "./MatchManager";

    export class MatchController {

        private game: Phaser.Game;
        private discardClick: boolean;
        private backgroundImage: Phaser.Image;

        constructor(game: Phaser.Game) {

            this.game = game;
            this.discardClick = false;

            // al volver a tener foco el navegador con un click este hace que se dispare el balon cuando esta en
            // el sacador o un jugador
            this.game.onResume.add(this.onGameResumed, this);
        }

        public init(backgroundImage: Phaser.Image): void {

            this.backgroundImage = backgroundImage;

            this.backgroundImage.inputEnabled = true;
            this.backgroundImage.input.priorityID = 0;
            this.backgroundImage.events.onInputDown.add(this.onClickInGameScene, this);
        }

        public destroy(): void {

            this.game.onResume.remove(this.onGameResumed, this);

            this.backgroundImage.events.onInputDown.remove(this.onClickInGameScene, this);
        }

        private onClickInGameScene ( event: any ): void {

            if ( GameVars.paused || GameVars.matchEnded || (!GameVars.isShooterReady && !GameVars.isBallAttachedToPlayer) || this.discardClick) {

                if (this.discardClick) {
                    this.discardClick = false;
                }

                return;
            }

            if (PenaltyFootballFieldState.currentInstance) {
                PenaltyManager.onClickInGameScene();
            } else {
                MatchManager.onClickInGameScene();
            }  
        }

        private onGameResumed(): void {

            this.discardClick = true;
        }
    }
